<div class="content">
  @if (isIEC()) {
    <div>
      <app-iec-riser-project-defaults [entity]="entity" (errorEvent)="handleError($event)">
      </app-iec-riser-project-defaults>
    </div>
  }
  @if (isCLM()) {
    <div>
      <app-clm-riser-project-defaults [entity]="entity" (errorEvent)="handleError($event)">
      </app-clm-riser-project-defaults>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
